import { dropBoolean } from 'utils/drops';

const getRegiaoEntidadeFilterFields = () => [
  { name: 'id', label: 'ID', type: 'number' },
  { name: 'descricao', label: 'Descrição', initial: true },
  { name: 'ativo', label: 'Ativo', type: 'select', options: dropBoolean },
];

export default getRegiaoEntidadeFilterFields;
